import { createSlice } from '@reduxjs/toolkit';
import AxiosService from '../../services/axios-service';
import { dispatch } from '../store';
import InsuranceRepository from '../../pages/insurance/repositories/InsuranceRepository';
import { removeCpfOrCnpjMask } from '../../utils/utils';

const initialState = {
	isLoading: false,
	error: false,
	insurance: null,
	insuranceForm: null,
	insurances: [],
	cities: [],
	states: [],
	brands: [],
	models: [],
	powers: [],
	periods: []
};

const slice = createSlice({
	name: 'insurance',
	initialState: initialState,
	reducers: {
		startLoading(state) {
			state.isLoading = true;
		},
		hasError(state, action) {
			state.isLoading = false;
			state.error = action.payload;
		},
		getInsuranceSuccess(state, action) {
			state.isLoading = false;
			state.insurance = action.payload;
		},
		getInsurancesSuccess(state, action) {
			state.isLoading = false;
			state.insurances = [...action.payload].sort((a, b) => b.id - a.id);
		},
		clearIsurance(state, action) {
			state.insurance = null;
		},
		clearIsuranceForm(state, action) {
			state.insuranceForm = null;
		},
		setInsuranceForm(state, action) {
			const newObject = {
				...state.insuranceForm,
				...action.payload
			};
			state.insuranceForm = newObject;
		},
		getStatesSuccess(state, action) {
			state.isLoading = false;
			state.states = action.payload;
		},
		getCitiesSuccess(state, action) {
			state.isLoading = false;
			state.cities = action.payload;
			state.filteredCities = action.payload;
		},
		getBrandsModelsPowers(state, action) {
			state.brands = action.payload.brands.map((brand) => ({ label: brand.nome, value: brand.id }));
			state.models = action.payload.models.map((model) => ({ label: model.nome, value: model.id }));
			state.powers = action.payload.powers.map((power) => ({ label: power.valor, value: power.id }));
		},
		getPeriodsSuccess(state, action) {
			state.periods = action.payload;
		}
	}
});

export default slice.reducer;

export const { clearIsurance, clearIsuranceForm, setInsuranceForm } = slice.actions;

export function getInsurances(cpfOrCnpj) {
	return async () => {
		try {
			dispatch(slice.actions.startLoading());
			const axiosService = new AxiosService();
			const normalizedCpfOrCnpj = encodeURIComponent(removeCpfOrCnpjMask(cpfOrCnpj));
			const response = await axiosService.get(`webapp/insurance/all/${normalizedCpfOrCnpj}`);
			dispatch(slice.actions.getInsurancesSuccess(response));
		} catch (error) {
			console.error(error)
			dispatch(slice.actions.hasError(error));
		}
	};
}

export function getInsuranceDetails(insuranceId) {
	return async () => {
		try {
			dispatch(slice.actions.startLoading());
			const axiosService = new AxiosService();
			const response = await axiosService.get(`webapp/insurance/byId/${insuranceId}`);
			dispatch(slice.actions.getInsuranceSuccess(response));
		} catch (error) {
			console.error(error)
			dispatch(slice.actions.hasError(error));
		}
	};
}

export function getStates() {
	return async () => {
		try {
			dispatch(slice.actions.startLoading());
			const axiosService = new AxiosService();
			const response = await axiosService.get(`localizacao/estado`);
			dispatch(slice.actions.getStatesSuccess(response.map((e) => ({ label: e.estado, value: e.id }))));
		} catch (error) {
			console.error(error)
			dispatch(slice.actions.hasError(error));
		}
	};
}

export function getCities() {
	return async () => {
		try {
			dispatch(slice.actions.startLoading());
			const axiosService = new AxiosService();
			const response = await axiosService.get(`localizacao/cidade`);
			dispatch(slice.actions.getCitiesSuccess(response.map((e) => ({ label: e.cidade, value: e.id, stateId: e.estado_id }))));
		} catch (error) {
			console.error(error)
			dispatch(slice.actions.hasError(error));
		}
	};
}

export function getBrandsModelsAndPowers() {
	return async () => {
		try {
			dispatch(slice.actions.startLoading());
			const axiosService = new AxiosService();
			const response = await axiosService.get(`webapp/brands-models-powers`);
			dispatch(slice.actions.getBrandsModelsPowers(response));
		} catch (error) {
			console.error(error)
			dispatch(slice.actions.hasError(error));
		}
	};
}

export function getPeriods() {
	return async () => {
		try {
			const periods = await InsuranceRepository.getPeriods();
			dispatch(slice.actions.getPeriodsSuccess(periods));
		} catch (error) {
			console.error(error)
			dispatch(slice.actions.hasError(error));
		}
	};
}
